/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPrinterTokenDto
 */
export interface GetPrinterTokenDto {
    /**
     * 
     * @type {string}
     * @memberof GetPrinterTokenDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterTokenDto
     */
    expiresAt?: string | null;
}

/**
 * Check if a given object implements the GetPrinterTokenDto interface.
 */
export function instanceOfGetPrinterTokenDto(value: object): value is GetPrinterTokenDto {
    return true;
}

export function GetPrinterTokenDtoFromJSON(json: any): GetPrinterTokenDto {
    return GetPrinterTokenDtoFromJSONTyped(json, false);
}

export function GetPrinterTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrinterTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
    };
}

export function GetPrinterTokenDtoToJSON(value?: GetPrinterTokenDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
        'expiresAt': value['expiresAt'],
    };
}

